module.exports = __webpack_public_path__ + "static/media/merged-graph.8cd75cc2.svg";